export default "__VITE_ASSET__GNFSUgVg__"